// UI strings for a need's candidate cards in Omat sanat (ownwords/NeedCards.tsx): where the
// candidate comes from, its example sentences and its caveat. Finnish (default) and English side by
// side; en has the same shape. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const needCardsFi = {
  /** Before the official words of the same pattern: "kuten izulion ’neliö’ < izula". */
  like: 'kuten',
  /** The cited wiki page, a link to its dictionary entry. */
  source: 'Lähde: wikin sivu',
  /** Under the built examples: they are rule-made, never attested. */
  example: 'esimerkki (koottu säännöillä)',
  /** The label of the caveat line. */
  note: 'Huom.',
  /** A decided need: its candidates behind a disclosure. */
  candidates: (n: number) => `Ehdokkaat (${n})`,
  /** The candidate count beside a need's heading. */
  count: (n: number) => (n === 1 ? '1 ehdokas' : `${n} ehdokasta`),
};

export const needCardsEn: typeof needCardsFi = {
  like: 'like',
  source: 'Source: wiki page',
  example: 'example (built by rule)',
  note: 'Note',
  candidates: (n: number) => `Candidates (${n})`,
  count: (n: number) => (n === 1 ? '1 candidate' : `${n} candidates`),
};

// Messages.needCards (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('needCards', needCardsFi, needCardsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof needCardsFi> {}
}
